"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createInternalReducer;
/**
 * Creates a Redux reducer to store the ponyfill.
 *
 * The ponyfill is used to check if React and Redux does not use a matching ponyfill.
 */
function createInternalReducer(ponyfill) {
  return function () {
    return {
      ponyfill: ponyfill
    };
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjcmVhdGVJbnRlcm5hbFJlZHVjZXIiLCJwb255ZmlsbCJdLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZWR1Y2Vycy9jcmVhdGVJbnRlcm5hbFJlZHVjZXIudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHR5cGUgeyBHbG9iYWxTY29wZVBvbnlmaWxsIH0gZnJvbSAnLi4vdHlwZXMvR2xvYmFsU2NvcGVQb255ZmlsbCc7XG5cbi8qKlxuICogQ3JlYXRlcyBhIFJlZHV4IHJlZHVjZXIgdG8gc3RvcmUgdGhlIHBvbnlmaWxsLlxuICpcbiAqIFRoZSBwb255ZmlsbCBpcyB1c2VkIHRvIGNoZWNrIGlmIFJlYWN0IGFuZCBSZWR1eCBkb2VzIG5vdCB1c2UgYSBtYXRjaGluZyBwb255ZmlsbC5cbiAqL1xuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gY3JlYXRlSW50ZXJuYWxSZWR1Y2VyKHBvbnlmaWxsOiBHbG9iYWxTY29wZVBvbnlmaWxsKTogKCkgPT4geyBwb255ZmlsbDogR2xvYmFsU2NvcGVQb255ZmlsbCB9IHtcbiAgcmV0dXJuICgpID0+ICh7IHBvbnlmaWxsIH0pO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFFQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ2UsU0FBU0EscUJBQXFCQSxDQUFDQyxRQUE2QixFQUEyQztFQUNwSCxPQUFPO0lBQUEsT0FBTztNQUFFQSxRQUFRLEVBQVJBO0lBQVMsQ0FBQztFQUFBLENBQUM7QUFDN0IifQ==